(function () {
  "use strict";

  /* ---------- CONFIG — edit these ---------- */
  var CONFIG = {
    sessionKey: "ft_popup_shown_v1",   // bump the "v1" if you ever want to force it to show again for everyone
    delayMs: 10000,                      // how long after page load before it pops up
    imageUrl: "https://cdn.shopify.com/s/files/1/0639/9829/6245/files/0-GraveDoubt-Final2.webp?v=1782713222",
    imageLink: "https://fionatarr.com/pages/newsletter-signup-dawn-grave", // where the image click goes
    imageAlt: "Join my readers club here",
    buttonText: "here",
    buttonLink: "https://fionatarr.com/pages/newsletter-signup-dawn-grave",
    bodyText: "Join my readers club and the Dawn Grave prequel novella FREE",
    // Only show if the referrer matches one of these (leave empty array [] to show for everyone regardless of source)
    // Matches against document.referrer's hostname, e.g. "google.com", "facebook.com", "instagram.com"
    allowedReferrers: [],
    // If true, only show on the very first page of the session (i.e. a true landing page hit).
    // If false, it'll still only show once per session, just not restricted to entry page.
    onlyOnEntryPage: true
  };
  /* ------------------------------------------ */

  // Already shown this session? Bail immediately.
  if (sessionStorage.getItem(CONFIG.sessionKey)) return;

  // Figure out if this is the entry page of the session (first page hit, no internal referrer)
  var entryKey = CONFIG.sessionKey + "_entry_checked";
  var isEntryPage = !sessionStorage.getItem(entryKey);
  sessionStorage.setItem(entryKey, "1");

  if (CONFIG.onlyOnEntryPage && !isEntryPage) return;

  // Referrer check (only meaningful on entry page; if referrer is same-site, treat as direct nav, allow through)
  if (CONFIG.allowedReferrers.length) {
    var refHost = "";
    try { refHost = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch (e) {}
    var sameSite = refHost && refHost === location.hostname.replace(/^www\./, "");
    var matches = !refHost || sameSite || CONFIG.allowedReferrers.some(function (d) { return refHost.indexOf(d) !== -1; });
    if (!matches) return;
  }

  function buildAndShow() {
    // Mark as shown immediately so a fast double-init or fast nav can't double-fire it
    sessionStorage.setItem(CONFIG.sessionKey, "1");

    var overlay = document.createElement("div");
    overlay.setAttribute("id", "ft-popup-overlay");
    overlay.style.cssText =
      "position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:99998;" +
      "display:flex;align-items:center;justify-content:center;padding:16px;";

    var box = document.createElement("div");
    box.style.cssText =
      "background:#fff;max-width:420px;width:100%;border-radius:8px;overflow:hidden;" +
      "position:relative;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,.3);";

    var closeBtn = document.createElement("button");
    closeBtn.innerHTML = "&times;";
    closeBtn.setAttribute("aria-label", "Close");
    closeBtn.style.cssText =
      "position:absolute;top:6px;right:10px;background:none;border:none;" +
      "font-size:26px;line-height:1;cursor:pointer;color:#333;z-index:1;";
    closeBtn.onclick = function () { overlay.remove(); };

    var imgLink = document.createElement("a");
    imgLink.href = CONFIG.imageLink;
    var img = document.createElement("img");
    img.src = CONFIG.imageUrl;
    img.alt = CONFIG.imageAlt;
    img.style.cssText = "width:100%;display:block;padding:50px;";
    imgLink.appendChild(img);

    var textWrap = document.createElement("p");
    textWrap.style.cssText = "padding:16px 20px 20px;margin:0;font-size:15px;";
    textWrap.textContent = CONFIG.bodyText;

    var link = document.createElement("a");
    link.href = CONFIG.buttonLink;
    link.textContent = CONFIG.buttonText;
    link.style.cssText = "font-weight:bold;text-decoration:underline;color:inherit;display:block;";

    textWrap.appendChild(link);

    box.appendChild(closeBtn);
    box.appendChild(imgLink);
    box.appendChild(textWrap);
    overlay.appendChild(box);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) overlay.remove();
    });

    document.body.appendChild(overlay);
  }

    window.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        var preload = new Image();
        var fallback = setTimeout(buildAndShow, 2000); // shows anyway if image is slow
        preload.onload = function () { clearTimeout(fallback); buildAndShow(); };
        preload.onerror = function () { clearTimeout(fallback); buildAndShow(); };
        preload.src = CONFIG.imageUrl;
    }, CONFIG.delayMs);
    });
})();